/**
 * How much of the viewport a bar pinned to an edge is covering, published on the
 * document root for whatever else pins there: the Sort & Filter rail and its
 * trigger. `0px` (the fallback in every `var()`) when nothing is pinned.
 *
 * Tailwind reads classes as plain text, so the classes that use these
 * (`top-[var(--pinned-top-height,0px)]` and the like) spell the names out; keep
 * them in step with these constants.
 */
export const PINNED_TOP_HEIGHT_VAR = '--pinned-top-height';
export const PINNED_BOTTOM_HEIGHT_VAR = '--pinned-bottom-height';
